module.exports = __webpack_public_path__ + "img/step15_b_basket_basic_fix_top_cross_to_stand_screws.197397be.png";